import BackButton from './back-button.vue';

export default BackButton;
